module.exports = __webpack_public_path__ + "img/formula.25a1df62.png";